<template>
  <div class="br">
    <div class="rp-hd">
      <div class="rp-title">
        <span style="width:8px;height:8px;border-radius:50%;background:var(--ok);flex-shrink:0;display:inline-block"></span>
        Kết quả phân tích
      </div>
      <div style="display:flex;gap:6px;align-items:center">
        <span style="font-size:10.5px;color:var(--t3)">GPT-4o</span>
      </div>
    </div>
    <div class="rp-scroll">
      <div class="ai-hint">
        <div class="hint-hd">
          <div class="hint-ico">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/></svg>
          </div>
          <div class="hint-title">AI nhận thấy trong tập hội thoại của bạn</div>
          <div class="hint-time">Cập nhật vừa xong</div>
        </div>
        <div class="hint-stats">
          <div class="hs"><div class="hs-num">32%</div><div class="hs-lbl">hội thoại nguy cơ rời bỏ</div></div>
          <div class="hs"><div class="hs-num">18</div><div class="hs-lbl">khách im lặng &gt;7 ngày</div></div>
          <div class="hs"><div class="hs-num">41</div><div class="hs-lbl">khách chờ phản hồi</div></div>
        </div>
        <div class="hint-suggest">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 9l-2 2-2-2M12 3v8M5 12a7 7 0 1014 0"/></svg>
          <span><strong>Gợi ý:</strong> AI có thể giúp bạn xác định khách hàng sắp rời đi và đề xuất kịch bản giữ chân hiệu quả.</span>
        </div>
      </div>

      <div v-if="show" class="fadein">
        <div v-if="isPreview" class="preview-banner">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
          <span>Đây là kết quả <strong>thử nghiệm</strong> trên 5 hội thoại mẫu — không lưu vào lịch sử.</span>
        </div>
        <div class="result-meta">
          <div style="flex:1;min-width:120px">
            <div class="rm-title">{{ title }}</div>
            <div class="rm-sub">Hội thoại theo bộ lọc · 30 ngày qua</div>
          </div>
          <div style="display:flex;align-items:center;gap:6px;flex-shrink:0">
            <span class="rm-badge">{{ isPreview ? 'Xem thử' : 'Kết quả chính thức' }}</span>
            <span style="font-size:10px;color:var(--t3)">vừa xong</span>
          </div>
        </div>
        <div class="out-card">
          <div class="oc-hd"><span class="oc-dot"></span><span class="oc-lbl">Phát hiện chính</span><span class="oc-sub">3 vấn đề nổi bật</span></div>
          <div class="oc-body">
            <div class="insight-list">
              <div class="ii"><div class="ii-m"></div><div class="ii-body"><strong>83 hội thoại</strong> không tương tác hơn 21 ngày dù đang ở bước lên đơn — có nguy cơ mất deal cao.<span class="ii-tag">Rủi ro cao</span></div></div>
              <div class="ii"><div class="ii-m"></div><div class="ii-body"><strong>41 hội thoại</strong> đã đọc tin nhắn nhưng chưa phản hồi — đang cân nhắc, cần thêm nội dung thuyết phục.<span class="ii-tag">Cần theo dõi</span></div></div>
              <div class="ii"><div class="ii-m"></div><div class="ii-body"><strong>29 hội thoại</strong> hỏi về bảng giá và tính năng nâng cao — tiềm năng chốt đơn trong 7 ngày tới.<span class="ii-tag">Cơ hội</span></div></div>
            </div>
          </div>
        </div>
        <div class="out-card">
          <div class="oc-hd"><span class="oc-dot"></span><span class="oc-lbl">Hành động đề xuất</span><span class="oc-sub">3 việc cần làm</span></div>
          <div class="oc-body">
            <div class="action-list">
              <div class="ai-row">
                <div class="ai-left"><div class="ai-icon"><i class="el-icon-phone"></i></div><div><div class="ai-name">Gọi điện chăm sóc lại</div><div class="ai-meta">83 hội thoại · Ưu tiên cao</div></div></div>
                <el-button size="mini">Tạo việc cần làm</el-button>
              </div>
              <div class="ai-row">
                <div class="ai-left"><div class="ai-icon"><i class="el-icon-message"></i></div><div><div class="ai-name">Gửi email nuôi dưỡng</div><div class="ai-meta">41 hội thoại · Nội dung case study</div></div></div>
                <el-button size="mini">Tạo chiến dịch</el-button>
              </div>
              <div class="ai-row">
                <div class="ai-left"><div class="ai-icon"><i class="el-icon-s-promotion"></i></div><div><div class="ai-name">Gửi báo giá ưu đãi</div><div class="ai-meta">29 hội thoại · Tiềm năng cao</div></div></div>
                <el-button size="mini" type="primary">Gửi ngay</el-button>
              </div>
            </div>
          </div>
        </div>
        <div style="display:flex;justify-content:center;gap:8px;margin-top:14px;padding-bottom:4px">
          <el-button size="small" icon="el-icon-view" @click="$emit('preview')">Xem thử lại</el-button>
          <el-button size="small" type="primary" icon="el-icon-video-play" @click="$emit('run')">Chạy toàn bộ</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SaleAIResultPanel',
  props: {
    show: { type: Boolean, default: false },
    isPreview: { type: Boolean, default: false },
    title: { type: String, default: '' },
  },
};
</script>
